import { IBankAccount } from "components/ezpay/secure/common/bank-account-modal";
import { ICreditDebitCard } from "components/ezpay/secure/common/credit-debit-modal";
import { IReceiptInfo } from "components/ezpay/secure/common/receipt-info-modal";
import FundingOption, {
  translateBankAccountType,
} from "constants/FundingOption";
import { getCardNetworkByShortCode } from "constants/FundingOption";
import { TFunction } from "i18next/typescript/t";

import { createSelector } from "reselect";
import {
  IPayablePaymentIntent,
  IPayableWallet,
} from "types/payablePaymentIntent";

export const getPayableBankAccount = (state: any): IBankAccount =>
  state.payablePaymentIntent.bankAccount;
export const getPayableCreditDebitCard = (state: any): ICreditDebitCard =>
  state.payablePaymentIntent.creditDebitCard;
export const getPayableWallet = (state: any): IPayableWallet =>
  state.payablePaymentIntent.wallet;
export const getPayableReceiptInfo = (state: any): IReceiptInfo =>
  state.payablePaymentIntent.receiptInfo;
export const getPayablePaymentIntent = (state: any): IPayablePaymentIntent =>
  state.payablePaymentIntent;
export const getPayablePaymentMethod = (state: any): string =>
  state.payablePaymentIntent.paymentMethod;
export const getPayableTranslationFunction = (state: any, t: TFunction) => t;

export const getPayablePaymentMethodLabel = createSelector(
  [
    getPayablePaymentMethod,
    getPayableBankAccount,
    getPayableCreditDebitCard,
    getPayableWallet,
    getPayableTranslationFunction,
  ],
  (
    payablePaymentMethod,
    payableBankAccount,
    payableCreditDebitCard,
    payableWallet,
    t
  ) => {
    let payablePaymentMethodLabel = "";
    if (
      payablePaymentMethod === FundingOption.BankAccount &&
      payableBankAccount
    ) {
      payablePaymentMethodLabel =
        translateBankAccountType(payableBankAccount.accountType, t) +
        " *" +
        payableBankAccount.bankAccountNumber.substring(
          payableBankAccount.bankAccountNumber.length - 4
        );
    } else if (
      payablePaymentMethod === FundingOption.Card &&
      payableCreditDebitCard
    ) {
      payablePaymentMethodLabel =
        payableCreditDebitCard.cardType +
        " *" +
        payableCreditDebitCard.cardNo.substring(
          payableCreditDebitCard.cardNo.length - 4
        );
    } else if (payablePaymentMethod === FundingOption.Wallet && payableWallet) {
      if (payableWallet.fundingOption == FundingOption.Card) {
        payablePaymentMethodLabel =
          getCardNetworkByShortCode(payableWallet.presentableMOPCode) +
          " " +
          payableWallet.maskedNumber;
      } else if (payableWallet.fundingOption === FundingOption.BankAccount) {
        payablePaymentMethodLabel =
          translateBankAccountType(payableWallet.presentableMOPCode, t) +
          " " +
          payableWallet.maskedNumber;
      }
    }
    return payablePaymentMethodLabel;
  }
);
